import { SET_START_TIME } from 'actions/booking/feSetBookingStartTime.types';

const feSetBookingStartTime = (startTime) => ({ type: SET_START_TIME, startTime });

export default feSetBookingStartTime;
